"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.zIndexDefault = exports.hoverOffset = exports.tooltipMaxWidth = exports.tooltipMaxHeight = exports.tooltipMargin = exports.tooltipId = exports.classes = void 0;
var classes = {
  tooltipContainer: 'bds-tooltip-container'
};
exports.classes = classes;
var tooltipId = 'bds-tooltip-modal';
exports.tooltipId = tooltipId;
var tooltipMargin = 8;
exports.tooltipMargin = tooltipMargin;
var tooltipMaxHeight = '50vh';
exports.tooltipMaxHeight = tooltipMaxHeight;
var tooltipMaxWidth = '25vw';
exports.tooltipMaxWidth = tooltipMaxWidth;
var hoverOffset = 10;
exports.hoverOffset = hoverOffset;
var zIndexDefault = 50;
exports.zIndexDefault = zIndexDefault;